import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // entities[entityKey] = { items: [], loading: false, error: null }
  entities: {}
};

function ensureEntity(state, entityKey) {
  if (!state.entities[entityKey]) {
    state.entities[entityKey] = {
      items: [],
      loading: false,
      error: null
    };
  }
  return state.entities[entityKey];
}

const crudSlice = createSlice({
  name: 'crud',
  initialState,
  reducers: {
    setLoading(state, action) {
      const { entityKey, loading } = action.payload;
      const entity = ensureEntity(state, entityKey);
      entity.loading = loading;
    },
    setItems(state, action) {
      const { entityKey, items } = action.payload;
      const entity = ensureEntity(state, entityKey);
      entity.items = items || [];
      entity.error = null;
    },
    addItem(state, action) {
      const { entityKey, item } = action.payload;
      const entity = ensureEntity(state, entityKey);
      entity.items.push(item);
    },
    updateItem(state, action) {
      const { entityKey, item } = action.payload;
      const entity = ensureEntity(state, entityKey);
      const id = item?.id ?? item?._id;
      if (!id) return;
      const index = entity.items.findIndex((i) => (i.id ?? i._id) === id);
      if (index !== -1) {
        entity.items[index] = item;
      }
    },
    removeItem(state, action) {
      const { entityKey, id } = action.payload;
      const entity = ensureEntity(state, entityKey);
      entity.items = entity.items.filter((i) => (i.id ?? i._id) !== id);
    },
    setError(state, action) {
      const { entityKey, error } = action.payload;
      const entity = ensureEntity(state, entityKey);
      entity.error = error || null;
    }
  }
});

export const { setLoading, setItems, addItem, updateItem, removeItem, setError } = crudSlice.actions;
export default crudSlice.reducer;
